// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorBoundary_wrapper__1yL9e","text":"ErrorBoundary_text__228OL","icon":"ErrorBoundary_icon__2VEPq","button":"ErrorBoundary_button__1_tYQ"};